import locale from 'live/init/global-locale'

export type IBowtieLanguageToModal = {
    language: 'pt_br' | 'en_us'
}

export type IBowtieLanguageActionSetLanguage = {
    type: 'SET_BOWTIE_LANGUAGE'
    payload: {
        newLanguage: 'pt_br' | 'en_us'
    }
}

export interface IBowtieLanguageActionSwitchLanguage {
    type: 'SWITCH_LANGUAGE'
}

export type IBowtieLanguageAction = IBowtieLanguageActionSetLanguage | IBowtieLanguageActionSwitchLanguage

const initialState: IBowtieLanguageToModal = {
    language: locale
}

export function bowtieLanguageReducer(state = initialState, action: IBowtieLanguageAction): IBowtieLanguageToModal {
    switch (action.type) {
        case 'SET_BOWTIE_LANGUAGE':
            return { language: action.payload.newLanguage ?? locale }

        case 'SWITCH_LANGUAGE':
            return { language: state.language === 'pt_br' ? 'en_us' : 'pt_br' }

        default:
            return state
    }
}
